export default {
    info: [
        {
            info: [
                {
                    a1: 'a1',
                    b: 'b',
                    c: '1',
                    d: '1'
                },
                {
                    a1: 'a1',
                    b: 'b',
                    c: '1',
                    d: '1'
                }
            ],
            count: {
                a2: '小计',
                c: '2',
                d: '2'
            }
        }
    ],
    count: {
        a2: '合计',
        c: '2',
        d: '2'
    }
}
